import React from "react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const PasswordChangedSuccess = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-blue-100 px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-md">
        <div className="bg-white shadow-xl rounded-2xl p-10 flex flex-col items-center text-center">
          <div className="flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-4 shadow-sm">
            <CheckCircle2 className="text-green-600 w-8 h-8" />
          </div>
          <h2 className="text-2xl font-bold mb-2 text-gray-800">Password Changed Successfully!</h2>
          <p className="text-gray-500 mb-6">Your password has been reset. You can now log in with your new password.</p>
          <Button className="w-full bg-blue-600 text-white hover:bg-blue-700 rounded-lg py-2 text-base font-semibold shadow-md" onClick={() => navigate('/login')}>
            Login Now
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PasswordChangedSuccess; 